/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
export enum TroyFoodPortalEndpoint {
  getTransactionsV1 = "/v1/transactions",
  getOrdersV1 = "/v1/orders",
  getMerchantGroupsV1 = "/v1/merchant-groups",
  getMerchantGroupsV2 = "/v2/merchant-groups",
}

export enum CommonEndpoint {
  uploadFileV2 = "/v2/upload-file",
}

export enum ReviewEndpoint {
  getReviewsV1 = "/v1/feedback/reviews",
  reportReviewV1 = "/v1/feedback/report-review", // /v1/feedback/report-review/{reviewID}
  reviewReplyV1 = "/v1/feedback/review-reply",
  getReviewOverviewsV1 = "/v1/feedback/overview",
  getReviewThrottle = "/v1/feedback/merchant-review-throttles",
  getMerchantGroupsMerchantIDs = "/v1/merchant-group/store/merchantids",
}

export enum DownloadCsvEndpoint {
  requestCsvReportV1 = "/download/v1/csv",
  getCsvStatusV1 = "/download/v1/generated-insights",
}

export enum HTTPStatus {
  OK = 200,
  NoContent = 204,
  BadRequest = 400,
  InternalServerError = 500,
}

export enum AuthorizationHeader {
  mexInsights = "x-mts-ssid",
}

export enum IncidentEndpoint {
  fetchIncidentsV1 = "/v1/merchant/incidentlist",
  fetchIncidentStat = "/v1/merchant/incidentstats",
}
